import styled from 'styled-components'
import Flex from 'components/Flex'

export const FooterFlex = styled(Flex)`
  gap: 15px;
`

export const Label = styled(Flex)`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #1b1f22;
  margin-bottom: 8px;
`
